/**
 * Product variant gallery – stub to satisfy theme script tag.
 * PDP variant gallery behavior is handled by product-variant-logger.js and main bundle.
 */
(function () {
  'use strict';
})();
